import React from 'react';
import { DisplayedProduct } from '../types/models';
import { GlobeAltIcon } from '@heroicons/react/24/outline';

interface ProductSelectionModalProps {
  products: DisplayedProduct[];
  isOpen: boolean;
  onSelect: (product: DisplayedProduct) => void;
  onClose: () => void;
}

const ProductSelectionModal: React.FC<ProductSelectionModalProps> = ({
  products,
  isOpen,
  onSelect,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }
  
  return (
    <div className="fixed inset-0 z-50 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center">
      <div className="bg-white p-5 rounded-lg shadow-xl w-1/2">
        <h3 className="text-lg font-bold mb-4">Выберите продукт</h3>
        <div className="max-h-96 overflow-y-auto">
          {products.map((product) => (
            <div
              key={product.code}
              className="p-3 hover:bg-gray-100 cursor-pointer border-b"
              onClick={() => onSelect(product)}
            >
              <p className="font-semibold">{product.description || 'Нет описания'}</p>
              <p className="text-sm text-gray-600">Бренд: {product.brand || 'Не указан'}</p>
              <p className="text-sm text-gray-600">Артикул: {product.vendor_code || 'Не указан'}</p>
              {/* Пометка для продуктов из интернета */}
              {product.source_url && (
                <div className="flex items-center mt-1">
                  <GlobeAltIcon className="h-3 w-3 text-blue-500 mr-1" />
                  <span className="text-xs text-blue-600 font-medium">Найден в интернете</span>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductSelectionModal;